import { MenuItem, TextField, TextFieldProps } from '@mui/material'
import { Control, Controller, FieldPath, FieldValues } from 'react-hook-form'
import { SelectOption } from '@/types'

export type SelectProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
  // name will come from controller
> = Omit<TextFieldProps, 'name'> & {
  name: TName
  options: SelectOption[] | string[]
  control: Control<TFieldValues>
}

export const SelectInput = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  name,
  options,
  control,
  ...textFieldProps
}: SelectProps<TFieldValues, TName>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          select
          {...field}
          {...textFieldProps}
          disabled={textFieldProps.disabled}
          error={!!error}
          helperText={error?.message || textFieldProps.helperText}
        >
          {options.map((option) => {
            if (typeof option === 'string') {
              return (
                <MenuItem
                  key={option}
                  value={option}
                  sx={{ whiteSpace: 'normal' }}
                >
                  {option}
                </MenuItem>
              )
            }

            return (
              <MenuItem
                key={option.value}
                value={option.value}
                sx={{ whiteSpace: 'normal' }}
              >
                {option.label}
              </MenuItem>
            )
          })}
        </TextField>
      )}
    />
  )
}
